import { quickCheckSoftPIPState } from '@core/pictureInPicture/quickCheckSoftPIPState'
import { quickCheckShareLinkParams } from '@core/sharing/helpers/quickCheckShareLinkParams'

/**
 * Load share link or soft PIP player state from local storage
 * if the url contains share link params for any version (v1 or v2)
 * or short link params.
 */
export function loadShareLinkOrSoftPIPLazy() {
  if (typeof window === 'undefined') {
    return
  }

  if (
    quickCheckSoftPIPState() ||
    quickCheckShareLinkParams(window.location.href)
  ) {
    import('./loadShareLinkOrSoftPIP').then(({ loadShareLinkOrSoftPIP }) => {
      /**
       * Ensures that any widget with a `clear_player_state` parameter
       * can clear the persisted player state first.
       *
       * Asynchronous to ensure widgets render first every time.
       */
      setTimeout(loadShareLinkOrSoftPIP)
    })
  }
}
